import TnC from './TnC';

export default TnC;